import React, { Component } from 'react';
import api from "./../../../../services/api";
import './style.css';
import { NavLink } from 'react-router-dom';
import { user_token } from './../../../../services/Auth';
import { Collapse } from "react-collapse";

//import da API
import { organizer } from './../../../../services/api';
let apiOrganizer = new organizer();

var token = localStorage.getItem(user_token);

//Classe para API
export default class CadastrosProfissional extends Component {
  constructor() {
    super();
    this.state = {
      nome: [],
      occupation_area: "",
      medical_specialty: "",
    }
    this.handleSelectOcup = this.handleSelectOcup.bind(this);
    this.handleSelectSpec = this.handleSelectSpec.bind(this);
  }

  handleSelectOcup(event) {
    this.setState({ occupation_area: event.target.value });
  }
  handleSelectSpec(event) {
    this.setState({ medical_specialty: event.target.value });
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    var request;
    if (this.state.occupation_area === "Medicina") {
      request = await apiOrganizer.getAllProfessionals([
        {
          header: 'authenticated',
          value: true,
        },
        {
          header: 'occupation_area',
          value: this.state.occupation_area,
        },
        {
          header: 'medical_specialty',
          value: this.state.medical_specialty,
        }
      ]);

    } else {
      request = await apiOrganizer.getAllProfessionals([
        {
          header: 'authenticated',
          value: true,
        },
        {
          header: 'occupation_area',
          value: this.state.occupation_area,
        },
      ])

    }
    console.log(request);
    console.log(request.data);
    this.setState({ nome: request.data });
  };

  render() {
    return (
      <>
        <div id="OG_div_filter">
          <p id="OG_title">Filtros</p>
          <select value={this.state.occupation_area} onChange={this.handleSelectOcup} id="OG_select" required>
            <option value="">Todos</option>
            <option value="Medicina">Medicina</option>
            <option value='Psicologia'>Psicologia</option>
            <option value='Fisioterapia'>Fisioterapia</option>
            <option value='Odontologia'>Odontologia</option>
            <option value='Enfermagem'>Enfermagem</option>
            <option value='Nutrição'>Nutrição</option>
            <option value='Outros'>Outros</option>
          </select>
          <Collapse isOpened={this.state.occupation_area === "Medicina"}>
            <select value={this.state.medical_specialty} onChange={this.handleSelectSpec} id="OG_select" required>
              <option value="">Todos</option>
              <option value='Acupuntura'>Acupuntura</option>
              <option value='Alergia e imunologia'>Alergia e imunologia</option>
              <option value='Anestesiologia'>Anestesiologia</option>
              <option value='Angiologia'>Angiologia</option>
              <option value='Cardiologia'>Cardiologia</option>
              <option value='Cirurgia cardiovascular'>Cirurgia cardiovascular</option>
              <option value='Cirurgia da mão'>Cirurgia da mão</option>
              <option value='Cirurgia de cabeça e pescoço'>Cirurgia de cabeça e pescoço</option>
              <option value='Cirurgia do aparelho digestivo'>Cirurgia do aparelho digestivo</option>
              <option value='Cirurgia geral'>Cirurgia geral</option>
              <option value='Cirurgia oncológica'>Cirurgia oncológica</option>
              <option value='Cirurgia pediátrica'>Cirurgia pediátrica</option>
              <option value='Cirurgia plástica'>Cirurgia plástica</option>
              <option value='Cirurgia torácica'>Cirurgia torácica</option>
              <option value='Cirurgia vascular'>Cirurgia vascular</option>
              <option value='Clínica médica'>Clínica médica</option>
              <option value='Coloproctologia'>Coloproctologia</option>
              <option value='Dermatologia'>Dermatologia</option>
              <option value='Endocrinologia e metabologia'>Endocrinologia e metabologia</option>
              <option value='Endoscopia'>Endoscopia</option>
              <option value='Gastroenterologia'>Gastroenterologia</option>
              <option value='Genética médica'>Genética médica</option>
              <option value='Geriatria'>Geriatria</option>
              <option value='Ginecologia e obstetrícia'>Ginecologia e obstetrícia</option>
              <option value='Hematologia e hemoterapia'>Hematologia e hemoterapia</option>
              <option value='Homeopatia'>Homeopatia</option>
              <option value='Infectologia'>Infectologia</option>
              <option value='Mastologia'>Mastologia</option>
              <option value='Medicina de emergência'>Medicina de emergência</option>
              <option value='Medicina de família e comunidade'>Medicina de família e comunidade</option>
              <option value='Medicina do trabalho'>Medicina do trabalho</option>
              <option value='Medicina de tráfego'>Medicina de tráfego</option>
              <option value='Medicina esportiva'>Medicina esportiva</option>
              <option value='Medicina física e reabilitação'>Medicina física e reabilitação</option>
              <option value='Medicina intensiva'>Medicina intensiva</option>
              <option value='Medicina legal e perícia médica'>Medicina legal e perícia médica</option>
              <option value='Medicina nuclear'>Medicina nuclear</option>
              <option value='Medicina preventiva e social'>Medicina preventiva e social</option>
              <option value='Nefrologia'>Nefrologia</option>
              <option value='Neurocirurgia'>Neurocirurgia</option>
              <option value='Neurologia'>Neurologia</option>
              <option value='Nutrologia'>Nutrologia</option>
              <option value='Oftalmologia'>Oftalmologia</option>
              <option value='Oncologia clínica'>Oncologia clínica</option>
              <option value='Ortopedia e traumatologia'>Ortopedia e traumatologia</option>
              <option value='Otorrinolaringologia'>Otorrinolaringologia</option>
              <option value='Patologia'>Patologia</option>
              <option value='Patologia clínica/medicina laboratorial'>Patologia clínica/medicina laboratorial</option>
              <option value='Pediatria'>Pediatria</option>
              <option value='Pneumologia'>Pneumologia</option>
              <option value='Psiquiatria'>Psiquiatria</option>
              <option value='Radiologia e diagnóstico por imagem'>Radiologia e diagnóstico por imagem</option>
              <option value='Radioterapia'>Radioterapia</option>
              <option value='Reumatologia'>Reumatologia</option>
              <option value='Urologia'>Urologia</option>
            </select>
          </Collapse>
          <button id="OG_filter_button" onClick={this.loadData}>ENVIAR</button>
        </div>

        <div id="lista-style">
          <hr id="divider-cp-Painel" />
          <br></br>
          {this.state.nome.map(name => (
            <>
              <NavLink to={{ pathname: '/Tela_Profissionais_Cadastrados/' + name._id }}>
                <button id="og-button" key={name._id}>{name.name}</button></NavLink>
            </>
          ))}
        </div>
      </>

    );
  }

}
